import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { CheckCircleIcon } from './CheckCircleIcon.js';

const SuccessCheckCircleIcon = forwardRef((props, ref) => {
    return jsx(CheckCircleIcon, Object.assign({ htmlColor: "#ffffff", backgroundColor: "primary" }, props, { ref: ref }));
});

export { SuccessCheckCircleIcon };
//# sourceMappingURL=SuccessCheckCircleIcon.js.map
